import UtilServices from "@services/UtilServices";
import { FileText, AlertCircle } from "lucide-react";
import React from "react";

export interface TaxRecord {
  codigoservico: string;
  nbs: string;
  descservico: string;
  descricaonbs: string;
  cstibscbs: string;
  cclasstrib: string;
  indop: string;
  descricaocclasstrib: string;
  aliquotaibs: string;
  aliquotacbs: string;
  seexporatacao: string;

  // comercio
  ncm: string;
  anexo: string;
  item: string;
  condicao: string;
  aliquotazeroreducao: string;
  baselegal: string;
}

const TituloStringWithTwo = ({
  status,
}: {
  status: {
    titulo1?: string;
    string: string;
    titulo2?: string;
    string2: string;
  };
}) => {
  return (
    <>
      <div>
        {status.titulo1 && (
          <p className="text-sm text-muted-foreground">{status.titulo1}</p>
        )}
        <span
          className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium text-emerald-400 bg-emerald-400/10`}
        >
          {status.string}
        </span>
      </div>
      <div className="mt-2">
        {status.titulo2 && (
          <p className="text-sm text-muted-foreground">{status.titulo2}</p>
        )}
        <span
          className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium text-yellow-400 bg-yellow-400/10`}
        >
          {status.string2}
        </span>
      </div>
    </>
  );
};
const TituloStringWithTwoFlex = ({
  status,
}: {
  status: {
    titulo1?: string;
    string: string;
    titulo2?: string;
    string2: string;
  };
}) => {
  return (
    <>
      <div className="flex items-center justify-center gap-1">
        <div>
          {status.titulo1 && (
            <p className="text-sm text-muted-foreground">{status.titulo1}</p>
          )}
          <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium text-white bg-secondary-tail/90`}
          >
            {status.string}
          </span>
        </div>
        <div>
          {status.titulo2 && (
            <p className="text-sm text-muted-foreground">{status.titulo2}</p>
          )}
          <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium text-white bg-secondary-tail/90`}
          >
            {status.string2}
          </span>
        </div>
      </div>
    </>
  );
};
const TituloStringWithThree = ({
  status,
}: {
  status: {
    titulo1?: string;
    string: string | React.ReactNode;
    titulo2?: string;
    string2: string | React.ReactNode;
    titulo3?: string;
    string3: string | React.ReactNode;
  };
}) => {
  return (
    <>
      <div>
        {status.titulo1 && (
          <p className="text-sm text-muted-foreground">{status.titulo1}</p>
        )}
        {status.string && (
          <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium text-emerald-400 bg-emerald-400/10`}
          >
            {status.string}
          </span>
        )}
      </div>
      <div className="mt-2">
        {status.titulo2 && (
          <p className="text-sm text-muted-foreground">{status.titulo2}</p>
        )}
        {status.string2 && (
          <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium text-emerald-400 bg-emerald-400/10`}
          >
            {status.string2}
          </span>
        )}
      </div>
      <div className="mt-2">
        {status.titulo3 && (
          <p className="text-sm text-muted-foreground">
            {UtilServices.stringToJsx(status.titulo3)}
          </p>
        )}
        {status.string3 && (
          <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium text-yellow-400 bg-yellow-400/10`}
          >
            {status.string3}
          </span>
        )}
      </div>
    </>
  );
};
const TituloStringWithThreeP2 = ({
  status,
}: {
  status: {
    titulo1?: string;
    string: string;
    titulo2?: string;
    string2: string;
    titulo3?: string;
    string3: string;
  };
}) => {
  return (
    <>
      <div>
        {status.titulo1 && (
          <p className="text-sm text-muted-foreground">{status.titulo1}</p>
        )}
        <span
          className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium text-blue-400 bg-blue-400/10`}
        >
          {status.string}
        </span>
      </div>
      <div className="mt-2">
        {status.titulo2 && (
          <p className="text-sm text-muted-foreground">{status.titulo2}</p>
        )}
        <span
          className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium text-blue-400 bg-blue-400/10`}
        >
          {status.string2}
        </span>
      </div>
      <div className="mt-2">
        {status.titulo3 && (
          <p className="text-sm text-muted-foreground">{status.titulo3}</p>
        )}
        {status.string3 && (
          <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium text-yellow-400 bg-yellow-400/10`}
          >
            {status.string3}
          </span>
        )}
      </div>
    </>
  );
};
const String = ({
  type,
}: {
  type: {
    string: string | React.ReactNode;
    string2?: string | React.ReactNode;
  };
}) => {
  return (
    <>
      <div className="text-start">
        <p className="font-medium text-foreground text-sm">{type.string}</p>
        {type.string2 && (
          <p className="text-xs text-muted-foreground font-mono">
            {type.string2}
          </p>
        )}
      </div>
    </>
  );
};

const columnsServico = [
  {
    label: "ITEM LC 116 & NBS",
    width: "w-28",
    align: "text-left",
  },
  { label: "Descrição do Serviço & NBS", width: "w-28", align: "text-left" },
  {
    label: "CST IBS/CBS & CCLASSTRIB",
    width: "w-28",
    align: "text-left",
  },
  {
    label: "INDOP & DESC.CCLASSTRIB",
    width: "w-28",
    align: "text-left",
  },
  {
    label: "Alíquota & Exportação",
    width: "w-28",
    align: "text-left",
  },
];
const columnsComercio = [
  {
    label: "NCM & ANEXO",
    width: "w-28",
    align: "text-left",
  },
  { label: "CONDIÇÃO", width: "w-28", align: "text-left" },
  {
    label: "TRIBUTAÇÃO",
    width: "w-28",
    align: "text-left",
  },
  {
    label: "CST & CLASSTRIB",
    width: "w-28",
    align: "text-left",
  },
  {
    label: "BASE LEGAL",
    width: "w-28",
    align: "text-left",
  },
];

export const DataTable = ({
  data,
  type,
}: {
  data: TaxRecord[];
  type: "servico" | "comercio" | "outras";
}) => {
  if (data.length === 0) {
    return (
      <div className="text-center py-16 animate-fade-up">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-secondary-tail flex items-center justify-center">
          <AlertCircle className="w-8 h-8 text-muted-foreground" />
        </div>
        <p className="text-muted-foreground">Sem resultados para exibir.</p>
      </div>
    );
  }
  return (
    <>
      {type === "servico" && (
        <div className="w-full overflow-hidden animate-fade-up">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-border-tail bg-primary-tail/10">
                  {columnsServico.map((col) => (
                    <th
                      className={`${col.align} ${
                        col.width ? col.width : ""
                      } text-sm py-2 px-3  text-primary-tail border-b border-primary-tail/20 text-left font-medium`}
                    >
                      {col.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-border-tail/50">
                {data.map((record, index) => (
                  <tr
                    key={index}
                    className="group hover:bg-secondary-tail/50 transition-colors duration-200"
                    style={{ animationDelay: `${index * 50}ms` }}
                  >
                    <td className="py-3 px-3">
                      <String
                        type={{
                          string: record.codigoservico,
                          string2: record.nbs,
                        }}
                      />
                    </td>
                    <td className="py-3 px-3">
                      <String
                        type={{
                          string: record.descservico,
                          string2: record.descricaonbs,
                        }}
                      />
                    </td>
                    <td className="py-3 px-3">
                      <TituloStringWithTwo
                        status={{
                          titulo1: "CST IBS/CBS",
                          string: record.cstibscbs,
                          titulo2: "CCLASSTRIB",
                          string2: record.cclasstrib,
                        }}
                      />
                    </td>
                    <td className="py-3 px-3">
                      <String
                        type={{
                          string: record.indop,
                          string2: record.descricaocclasstrib,
                        }}
                      />
                    </td>
                    <td className="py-3 px-3">
                      <TituloStringWithThree
                        status={{
                          string: `Alíquota: ${record.aliquotaibs}`,
                          string2: `Alíquota: ${record.aliquotacbs}`,
                          string3: (
                            <div className="">
                              <div className="flex items-center gap-1 mb-1">
                                <AlertCircle className="w-4 h-4 text-yellow-400" />
                                Se exportação:
                              </div>
                              <span>{record.seexporatacao}</span>
                            </div>
                          ),
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {(type === "comercio" || type === "outras") && (
        <div className="w-full overflow-hidden animate-fade-up">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-border-tail bg-primary-tail/10">
                  {columnsComercio.map((col) => (
                    <th
                      className={`${col.align} ${
                        col.width ? col.width : ""
                      } text-sm py-2 px-3  text-primary-tail border-b border-primary-tail/20 text-left font-medium`}
                    >
                      {col.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-border-tail/50">
                {data.map((record, index) => (
                  <tr
                    key={index}
                    className="group hover:bg-secondary-tail/50 transition-colors duration-200"
                    style={{ animationDelay: `${index * 50}ms` }}
                  >
                    <td className="py-3 px-3">
                      <TituloStringWithThree
                        status={{
                          string: `NCM: ${record.ncm}`,
                          string2: record.anexo ? `${record.anexo}` : null,
                          string3: record.item ? `${record.item}` : null,
                        }}
                      />
                    </td>
                    <td className="py-3 px-3">
                      <String
                        type={{
                          string: record.condicao,
                        }}
                      />
                    </td>
                    <td className="py-3 px-3">
                      <TituloStringWithThreeP2
                        status={{
                          titulo1: "IBS",
                          string: record.aliquotaibs,
                          titulo2: "CBS",
                          string2: record.aliquotacbs,
                          string3: record.aliquotazeroreducao
                            ? record.aliquotazeroreducao
                            : null,
                        }}
                      />
                    </td>
                    <td className="py-3 px-3">
                      <TituloStringWithTwoFlex
                        status={{
                          string: `CST: ${record.cstibscbs}`,
                          string2: `ClassTrib: ${record.cclasstrib}`,
                        }}
                      />
                    </td>
                    <td className="py-3 px-3">
                      {record.baselegal && (
                        <String
                          type={{
                            string: (
                              <div>
                                <div className="flex items-center gap-1 mb-1 bg-secondary-tail/90 p-2 rounded-md">
                                  <FileText className="w-4 h-4 text-white" />
                                  {record.baselegal}
                                </div>
                              </div>
                            ),
                          }}
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};
